import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignPermissionsRequest = {};
var _assignPermissionsResponse = {};
var _assignPermissionsToUserRequest = {};
var _assignUsersRequest = {
    startDate: 'google.protobuf.Timestamp',
    expiryDate: 'google.protobuf.Timestamp',
};
var _assignUsersResponse = {};
var _copyPermissionsRequest = {};
var _copyPermissionsResponse = {};
var _createRequest = { group: '_groupInfo' };
var _createResponse = { group: '_groupInfo' };
var _deleteRequest = {};
var _deleteResponse = {};
var _getCurrentUserGroupsRequest = {};
var _getCurrentUserGroupsResponse = { groups: '_groupInfo' };
var _getRequest = {};
var _getResponse = { group: '_groupInfo' };
var _groupData = {
    startDate: 'google.protobuf.Timestamp',
    expiryDate: 'google.protobuf.Timestamp',
    group: '_groupInfo',
};
var _groupInfo = {
    creationDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
};
var _groups = { group: '_groupInfo' };
var _groupsCountRequest = {};
var _groupsCountResponse = {};
var _groupsData = { groupsData: '_groupData' };
var _listPermissionsRequest = {};
var _listPermissionsResponse = {};
var _listRequest = {};
var _listResponse = { groups: '_groupInfo' };
var _listUserMembershipsRequest = {};
var _listUserMembershipsResponse = { memberships: '_membership' };
var _listUsersGroupsByMetaSitesRequest = {};
var _listUsersGroupsByMetaSitesResponse = {
    userGroupsData: 'Map#_groupsData',
};
var _listUsersGroupsRequest = {};
var _listUsersGroupsResponse = {
    usersGroups: 'Map#_groups',
    userGroupsData: 'Map#_groupsData',
};
var _listUsersPermissionsRequest = {};
var _listUsersPermissionsResponse = {};
var _listUsersRequest = {};
var _listUsersResponse = {};
var _membership = {
    startDate: 'google.protobuf.Timestamp',
    expiryDate: 'google.protobuf.Timestamp',
};
var _removePermissionsFromUserRequest = {};
var _removePermissionsRequest = {};
var _removePermissionsResponse = {};
var _removeUserFromGroupsRequest = {};
var _removeUserFromGroupsResponse = {};
var _removeUsersRequest = {};
var _removeUsersResponse = {};
var _updateRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    group: '_groupInfo',
};
var _updateResponse = { group: '_groupInfo' };
var _updateUserMembershipDatesRequest = {
    startDate: 'google.protobuf.Timestamp',
    expiryDate: 'google.protobuf.Timestamp',
};
var _updateUserMembershipDatesResponse = {};
function resolveComWixpressMembersGroupsGroupsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members-groups-web',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/members-groups-web/v1',
                destPath: '/v1',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/members-groups-web/v1',
                destPath: '/v1',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/wow/babel/_api/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/wow/babel/_api/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/wow/babel/_api/members-groups-web',
                destPath: '',
            },
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/members-groups-web/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members-groups-web',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members-groups-web/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * <!--ONLY:VELO Gets the member's roles.
 *
 * The `getRoles()` function returns a Promise that resolves to the
 * roles](https://support.wix.com/en/article/creating-member-roles-6943237)
 * the currently logged-in member or rejects if there is no logged-in member.
 *
 * > **Note:**
 * > This function replaces the deprecated
 * > `currentUser.getRoles()` from `wix-users-backend`.
 * > The deprecated function will continue to work, but it will not receive updates.
 * > To keep any existing code compatible with future changes, see the
 * > [migration instructions](wix-users-backend/currentUser/getroles#migration-instructions).
 *
 * If the current member is a site collaborator with site admin permissions,
 * the returned array will include `{"name": "Admin"}`,
 * as well as any assigned member roles.
 *
 * > **Note:**
 * > The APIs in `wix-members-backend` are only partially functional when previewing your site.
 * > View a published version of your site to see their complete functionality.
 * <!--END:ONLY:VELO-->
 *
 * <!--ONLY:REST-->
 * Returns a list of groups assigned to the current user
 * <!--END:ONLY:REST-->
 */
export function getCurrentUserGroups(payload) {
    var _a = serializer(_getCurrentUserGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentUserGroupsResponse, {
        _groupInfo: _groupInfo,
    }).fromJSON;
    function __getCurrentUserGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.GetCurrentUserGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentUserGroups.fromReq = fromReq;
    __getCurrentUserGroups.__isAmbassador = true;
    return __getCurrentUserGroups;
}
/** Returns a list of groups */
export function list(payload) {
    var _a = serializer(_listRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResponse, { _groupInfo: _groupInfo }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.List',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                        protoPath: '/v1/groups',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/** Returns a map of group_id and total members count in group */
export function getGroupsCount(payload) {
    var _a = serializer(_groupsCountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_groupsCountResponse, {}).fromJSON;
    function __getGroupsCount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.GetGroupsCount',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/count',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupsCount.fromReq = fromReq;
    __getGroupsCount.__isAmbassador = true;
    return __getGroupsCount;
}
/** Returns group by group_id */
export function get(payload) {
    var _a = serializer(_getRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResponse, { _groupInfo: _groupInfo }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.Get',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/** Creates a new group */
export function create(payload) {
    var _a = serializer(_createRequest, {
        _groupInfo: _groupInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createResponse, { _groupInfo: _groupInfo }).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.Create',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/** Updates existing group */
export function update(payload) {
    var _a = serializer(_updateRequest, {
        _groupInfo: _groupInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateResponse, { _groupInfo: _groupInfo }).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'PATCH',
            methodFqn: 'com.wixpress.members.groups.GroupsService.Update',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{group.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Deletes a group by group_id */
export function _delete(payload) {
    var _a = serializer(_deleteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.groups.GroupsService._Delete',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/** Return list of groups assigned to given users */
export function listUsersGroups(payload) {
    var _a = serializer(_listUsersGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUsersGroupsResponse, {
        _groupData: _groupData,
        _groupInfo: _groupInfo,
        _groups: _groups,
        _groupsData: _groupsData,
    }).fromJSON;
    function __listUsersGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListUsersGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/listGroups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUsersGroups.fromReq = fromReq;
    __listUsersGroups.__isAmbassador = true;
    return __listUsersGroups;
}
/** Return list of groups assigned to given user on specific meta sites */
export function listUsersGroupsByMetaSites(payload) {
    var _a = serializer(_listUsersGroupsByMetaSitesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUsersGroupsByMetaSitesResponse, { _groupData: _groupData, _groupInfo: _groupInfo, _groupsData: _groupsData }).fromJSON;
    function __listUsersGroupsByMetaSites(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListUsersGroupsByMetaSites',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/user/listGroups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUsersGroupsByMetaSites.fromReq = fromReq;
    __listUsersGroupsByMetaSites.__isAmbassador = true;
    return __listUsersGroupsByMetaSites;
}
/** Returns list of users in group */
export function listUsers(payload) {
    var _a = serializer(_listUsersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUsersResponse, {}).fromJSON;
    function __listUsers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListUsers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/users',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUsers.fromReq = fromReq;
    __listUsers.__isAmbassador = true;
    return __listUsers;
}
/** Assigns users to group */
export function assignUsers(payload) {
    var _a = serializer(_assignUsersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignUsersResponse, {}).fromJSON;
    function __assignUsers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.AssignUsers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/users',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignUsers.fromReq = fromReq;
    __assignUsers.__isAmbassador = true;
    return __assignUsers;
}
/** Removes users from group */
export function removeUsers(payload) {
    var _a = serializer(_removeUsersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeUsersResponse, {}).fromJSON;
    function __removeUsers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.RemoveUsers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/users/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeUsers.fromReq = fromReq;
    __removeUsers.__isAmbassador = true;
    return __removeUsers;
}
/** Returns user memberships */
export function listUserMemberships(payload) {
    var _a = serializer(_listUserMembershipsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUserMembershipsResponse, {
        _membership: _membership,
    }).fromJSON;
    function __listUserMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListUserMemberships',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/{userId}/memberships',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUserMemberships.fromReq = fromReq;
    __listUserMemberships.__isAmbassador = true;
    return __listUserMemberships;
}
/** Remove user from all groups */
export function removeUserFromGroups(payload) {
    var _a = serializer(_removeUserFromGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeUserFromGroupsResponse, {}).fromJSON;
    function __removeUserFromGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.RemoveUserFromGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/{userId}/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeUserFromGroups.fromReq = fromReq;
    __removeUserFromGroups.__isAmbassador = true;
    return __removeUserFromGroups;
}
/** Updating user memberships dates */
export function updateUserMembershipDates(payload) {
    var _a = serializer(_updateUserMembershipDatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateUserMembershipDatesResponse, {}).fromJSON;
    function __updateUserMembershipDates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'PATCH',
            methodFqn: 'com.wixpress.members.groups.GroupsService.UpdateUserMembershipDates',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/{userId}/membership',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateUserMembershipDates.fromReq = fromReq;
    __updateUserMembershipDates.__isAmbassador = true;
    return __updateUserMembershipDates;
}
/** List group permissions */
export function listPermissions(payload) {
    var _a = serializer(_listPermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPermissionsResponse, {}).fromJSON;
    function __listPermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'GET',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListPermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/permissions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPermissions.fromReq = fromReq;
    __listPermissions.__isAmbassador = true;
    return __listPermissions;
}
/** List user permissions */
export function listUsersPermissions(payload) {
    var _a = serializer(_listUsersPermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUsersPermissionsResponse, {}).fromJSON;
    function __listUsersPermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.ListUsersPermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/permissions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUsersPermissions.fromReq = fromReq;
    __listUsersPermissions.__isAmbassador = true;
    return __listUsersPermissions;
}
/** Assigns permissions to a group */
export function assignPermissions(payload) {
    var _a = serializer(_assignPermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignPermissionsResponse, {}).fromJSON;
    function __assignPermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.AssignPermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/permissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignPermissions.fromReq = fromReq;
    __assignPermissions.__isAmbassador = true;
    return __assignPermissions;
}
/** Removes permissions from group */
export function removePermissions(payload) {
    var _a = serializer(_removePermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removePermissionsResponse, {}).fromJSON;
    function __removePermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.RemovePermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/{groupId}/permissions/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removePermissions.fromReq = fromReq;
    __removePermissions.__isAmbassador = true;
    return __removePermissions;
}
/** Assigns Permission to a user */
export function assignPermissionsToUser(payload) {
    var _a = serializer(_assignPermissionsToUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignPermissionsResponse, {}).fromJSON;
    function __assignPermissionsToUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.AssignPermissionsToUser',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/{userId}/permissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignPermissionsToUser.fromReq = fromReq;
    __assignPermissionsToUser.__isAmbassador = true;
    return __assignPermissionsToUser;
}
/** Removes permissions from a user */
export function removePermissionsFromUser(payload) {
    var _a = serializer(_removePermissionsFromUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removePermissionsResponse, {}).fromJSON;
    function __removePermissionsFromUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.RemovePermissionsFromUser',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/groups/users/{userId}/permissions/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removePermissionsFromUser.fromReq = fromReq;
    __removePermissionsFromUser.__isAmbassador = true;
    return __removePermissionsFromUser;
}
export function copyPermissions(payload) {
    var _a = serializer(_copyPermissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_copyPermissionsResponse, {}).fromJSON;
    function __copyPermissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.members_groups.v1.group_info',
            method: 'POST',
            methodFqn: 'com.wixpress.members.groups.GroupsService.CopyPermissions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersGroupsGroupsServiceUrl({
                protoPath: '/v1/permissions/copy-permissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __copyPermissions.fromReq = fromReq;
    __copyPermissions.__isAmbassador = true;
    return __copyPermissions;
}
//# sourceMappingURL=http.impl.js.map